import { STATUSPAGE } from '@repo/ui';
import { HoursMinutes } from 'domain/value-objects/hours-minutes';
import Skeleton from 'react-loading-skeleton';
import { Card, CardBody, Col } from 'reactstrap';

export type WidgetData = {
  label: string;
  value: HoursMinutes;
  icon: string;
  color: string;
};

interface IProps {
  statusPage: STATUSPAGE;
  darkMode: 'dark' | 'light';
  widgetData: WidgetData;
}

export const WorkloadWidget = ({
  widgetData,
  statusPage,
  darkMode,
}: IProps) => {
  return (
    <Col sm={4}>
      <Card
        className={`bg-${darkMode === 'dark' ? 'light' : widgetData?.color}`}
      >
        <CardBody>
          <div className="d-flex align-items-center m-2">
            <div className="flex-grow-1">
              <h4 className="fs-4 text-white">
                <span className="counter-value">
                  {statusPage === STATUSPAGE.LOADING ? (
                    <Skeleton width={80} />
                  ) : (
                    `${widgetData?.value?.hours}h ${widgetData?.value?.minutes}min`
                  )}
                </span>
              </h4>
              <span className="fw-normal text-white">{widgetData?.label}</span>
            </div>

            <div className="flex-shrink-0">
              <h1 className="text-white">
                <i className={widgetData?.icon}></i>
              </h1>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
